import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import { api } from "../lib/api";

export default function CoreDashboard() {
  const [personas, setPersonas] = useState([]);
  useEffect(() => { api.listPersonas().then(setPersonas).catch(() => {}); }, []);

  const steps = [
    { to: "/personas", n: "01", label: "Definir Persona", desc: "Quem você quer adquirir." },
    { to: "/locais", n: "02", label: "Identificar Locais", desc: "Onde ela circula no mundo real." },
    { to: "/zonas", n: "03", label: "Zonas de Intenção", desc: "Clusters de oportunidade." },
    { to: "/campanhas", n: "04", label: "Ativar Campanha", desc: "Plano geointeligente pronto." },
    { to: "/performance", n: "05", label: "Otimizar", desc: "CAC, ROI, redistribuição." },
  ];

  return (
    <Layout>
      <h1 className="text-2xl font-bold">Dashboard</h1>
      <p className="text-neutral-400 text-sm mt-1">
        O Tomahawk identifica onde sua persona circula no mundo real e
        transforma esses lugares em aquisição previsível de clientes.
      </p>
      <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-3">
        <div className="rounded-lg border border-neutral-800 bg-neutral-900/50 p-4">
          <div className="text-xs text-neutral-500">Personas ativas</div>
          <div className="text-3xl font-bold mt-1">{personas.length}</div>
        </div>
      </div>
      <div className="mt-8 grid grid-cols-1 md:grid-cols-5 gap-3">
        {steps.map((s) => (
          <Link key={s.to} to={s.to}
            className="rounded-lg border border-neutral-800 bg-neutral-900/50 p-4 hover:border-red-600/50 transition-colors">
            <div className="text-red-500 text-xs font-bold">{s.n}</div>
            <div className="font-medium mt-1 text-sm">{s.label}</div>
            <div className="text-xs text-neutral-500 mt-1">{s.desc}</div>
          </Link>
        ))}
      </div>
    </Layout>
  );
}
